module.exports = __webpack_public_path__ + "img/BRI-background.8cccb033.jpg";